import { ticketBase } from './ipConfig';

/************************************************* 票务  *************************************************************/
//  获取门票
export const getAllTicketUrl = ticketBase + '/ticket-api/api/ticketServer/ticket.json';
//  获取临展列表
export const getAllExhibitionUrl = ticketBase + '/ticket-api/api/ticketServer/ticketInfos.json';
//  获取博物馆大门票日历接口
export const getCalendarUrl = ticketBase + '/ticket-api/api/ticketServer/appoints.json';
//  获取临时展览详情接口
export const getExhibitionDetailUrl = ticketBase + '/ticket-api/api/exhibitions/detail.json';
//  提交门票预约接口
export const commitOrderTicketUrl = ticketBase + '/ticket-api/api/ticketServer/orderTickets.json';
//  获取活动类型接口
export const getActivityTypeUrl = ticketBase + '/ticket-api/api/activities/types.json';
//  获取活动列表接口
export const getActivityListUrl = ticketBase + '/ticket-api/api/activities/list.json';
//  获取活动详情接口
export const getActivityDetailUrl = ticketBase + '/ticket-api/api/activities/detail.json';
//  提交报名活动接口
export const commitActivitySignUpUrl = ticketBase + '/ticket-api/api/activities/signUp.json';
//  检查活动是否已经报名
export const checkActivitysignUpUrl = ticketBase + '/ticket-api/api/activities/isExist.json'

//我的报名
export const myApplication = ticketBase + '/ticket-api/api/activities/myApplication.json'//我的报名
//我的门票
export const booked = ticketBase + '/ticket-api/api/ticketServer/booked.json'
//取消预约
export const cancel = ticketBase + '/ticket-api/api/activities/cancel.json'
//报名活动详情
export const applicationDetail = ticketBase + '/ticket-api/api/activities/applicationDetail.json'
//临展详情
export const bookedDetail = ticketBase + '/ticket-api/api/ticketServer/bookedDetail.json'
//活动 详情内取消预约
export const activitiesUserCancel = ticketBase + '/ticket-api/api/ctivities/userCancel.json'
//门票 详情内取消预约
export const ticketUserCancel = ticketBase + '/ticket-api/api/ticketServer/userCancel.json'
//活动 二维码
export const activitiesQRCode = ticketBase + '/ticket-api/api/activities/qrCode.json'
//门票 二维码
export const ticketQRCode = ticketBase + '/ticket-api/api/ticketServer/qrcodes.json'